export class PortfolioType {
    description: string = "";
    profitVallue: number = 0;
    netValueProjected: number = 0;
    bondList: Array<any> = [];
    otherBanksProjected: number = 0;
    savingsProjected: number = 0;
    bondCount: number = 0;
    valueToInvest: number = 0;
    finalRate: number = 0;
}